<template>
  <div>
    <!-- 内容主体区域 -->
    <div class="container">
      <!-- 头部 -->
      <div class="top">
        <div class="t-left">
          <div class="t-f-1">中国足球协会·网上信访</div>
          <div class="t-f-2">Chinese Football Association · Smart Petition Assistance System</div>
        </div>
        <div class="t-right" v-show="this.$store.state.token">
          <div class="t-r-1">欢迎,{{ this.$store.state.userInfo.nickName }}</div>
          <div class="t-r-2" @click="logout">
            <img src="../assets/关闭.png" alt="">
            <p>退出系统</p>
          </div>
        </div>
      </div>

      <!-- nav -->
      <div class="navMain">
        <div class="m-title">
          <div class="m-t-item active">投诉请求</div>
          <div @click="toJY" class="m-t-item">建议征集</div>
          <div @click="toJL" class="m-t-item">信访记录</div>
          <div @click="toNews" class="m-t-item">个人信息</div>
          <div @click="toPass" class="m-t-item">修改密码</div>
          <div @click="toHelp" class="m-t-item">帮助</div>
        </div>
      </div>

      <!-- 主体 -->
      <div class="main">
        <!-- 投诉须知 -->
        <div class="content" v-show="Guidelines">
          <div class="c-title">投诉须知</div>
          <div class="c-cont">
            <p>一、请您按照要求，准确填写投诉标题、诉求详情等信息，特别是详细提供所反映问题的时间、地点、人物、过程、涉及财物和造成的后果等。如有具体证据，请通过附件上传；如有其他证人，请在诉求详情中提供其姓名、联系方式等。
            </p>
            <p>二、提倡实名举报并优先受理。进行实名举报的，请详细填写真实姓名、身份证号、准确联系方式等内容。</p>
            <p>三、根据《信访工作条例》等有关规定，对于信访人提出的网上信访事项，已经受理或正在办理的；已经复核，仍然以同一事实和理由提出投诉请求的；涉法涉诉信访事项已经依法终结的，不转送、交办。</p>
            <p>四、涉及诉讼、仲裁、政府信息公开等事项，请您按照法定途径向有关机关、单位提出；涉及平等主体之间的民事纠纷、经济纠纷事项，请您按有关法律规定，通过司法程序解决。</p>
            <p>五、不受理事实不清、责任主体不明的信访事项。</p>
            <p>六、请您在网上信访过程中，自觉遵守法律、法规和以下规定</p>
            <p class="p-indent">1.不得损害国家、社会、集体的利益和其他公民的合法权利；</p>
            <p class="p-indent">2.不得提交含有违法信息的内容，不得使用攻击、谩骂等不文明语言；</p>
            <p class="p-indent">3.不得以信访为名谋利或借机敛财；</p>
            <p class="p-indent">4.不得扰乱公共秩序和网上信访工作秩序，避免频繁提交网上信访占用过多公共资源；</p>
            <p class="p-indent">5.不得捏造、歪曲事实，诬告、陷害他人，提交诉求时，须客观、真实、准确勾选、填写相关内容，并为所提交内容的真实性负责。</p>
            <p>如有违反，将承担相应责任。</p>
            <div class="checkContainer">
              <el-checkbox v-model="checked">我已阅读以上条款</el-checkbox>
            </div>
            <div class="btnContainer">
              <img class="noC" v-show="!checked" src="../assets/img1.gif" alt="">
              <img class="Can" v-show="!checked" src="../assets/img2.gif" alt="">
              <img class="noC tiaozhuan" @click="toShiMing" v-show="checked" src="../assets/img3.gif" alt="">
              <!-- 登录后不能匿名-->
              <template v-if="this.$store.state.userInfo && this.$store.state.userInfo.nickName">
                <img class="Can" src="../assets/img2.gif" v-show="checked" alt="">
              </template>
              <template v-else>
                <img class="Can tiaozhuan" @click="toNiMing" v-show="checked" src="../assets/img4.gif" alt="">
              </template>
            </div>
          </div>
        </div>

        <!-- 表格区域 (匿名)-->
        <div class="form-content" v-show="isAnonymousForm">
          <div class="f-title">信访诉求登记<span> (*为必填项)</span></div>
          <div class="f-cont">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">

              <el-form-item label="投诉标题" prop="complaintTitle" class="form-style">
                <el-input v-model="ruleForm.complaintTitle" style="width: 880px;" placeholder="请输入投诉标题"></el-input>
              </el-form-item>

              <!-- <el-form-item label="问题分类" prop="problemCategory" class="form-style">
                <el-select v-model="ruleForm.problemCategory" placeholder="请选择问题分类" :multiple="false"
                  style="width: 880px;">
                  <el-option v-for="item in troubleList" :key="item.qcId" :value="item.categoryName">
                  </el-option>
                </el-select>
              </el-form-item> -->

              <el-form-item label="电子邮箱" prop="anonymityEmail" class="form-style">
                <el-input v-model="ruleForm.anonymityEmail" style="width: 880px;" placeholder="请输入电子邮箱"></el-input>
              </el-form-item>

              <el-form-item label="问题所属协会" prop="association" class="form-SSXH">
                <el-select v-model="ruleForm.association" placeholder="请选择问题所属协会" style="width: 880px;">
                  <el-option v-for="item in associationList" :key="item.value" :value="item.association">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="问题发生地" class="form-style" prop="problemLocationList">
                <el-cascader v-model="ruleForm.problemLocationList" placeholder="请选择问题发生地" :props="props" @expand-change="expandChange" @change="changeCascader" ref="cascader2"
                  style="width: 880px;"></el-cascader>
              </el-form-item>
              <el-form-item>
                <div class="upload-demo">
                  <el-upload class="upload-demo" :action="uploadUrl" :on-preview="handlePreview"
                    :on-remove="handleRemove" :limit="5" name="files" :headers="uploadHeaders" :on-exceed="handleExceed"
                    :file-list="ruleForm.fileList" :before-upload="beforeUpload" :on-error="handleError"
                    :on-success="successUpload">
                    <el-button size="small" type="primary" style="height: 35px;">上传附件</el-button>
                    <div slot="tip" class="el-upload__tip">
                      支持格式:doc、docx、txt、pdf、xls、xlsx、jpg、jpeg、png、mp3、mp4、avi、mov、mkv、flv，单个文件不能超过100MB,最多上传五个文件</div>
                  </el-upload>
                </div>

              </el-form-item>
              <el-row class="switch-con">
                <el-col :span="6">
                  <el-form-item label="是否已有信访记录" prop="hasPetitionRecord" class="form-style">
                    <el-switch class="switch-con-left-one" v-model="ruleForm.hasPetitionRecord" :active-value="1"
                      :inactive-value="0"></el-switch>
                  </el-form-item>
                </el-col>

                <el-col :span="18">
                  <el-form-item label="相关处理结果" prop="petitionResult" class="form-style">
                    <el-input v-model="ruleForm.petitionResult" :disabled="ruleForm.hasPetitionRecord === 0"
                      placeholder="请输入相关处理结果"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- <el-row class="switch-con">
                <el-col :span="6">
                  <el-form-item label="是否联名信访" prop="jointPetition" class="form-style">
                    <el-switch class="switch-con-left-two" v-model="ruleForm.jointPetition" :active-value="1" :inactive-value="0"></el-switch>
                  </el-form-item>
                </el-col>

                <el-col :span="18">
                  <el-form-item class="form-num form-style" prop="jointPetitionCount" label="联名人数" >
                    <el-input type="number" @input="validateInput" @blur="handleBlur" v-model="ruleForm.jointPetitionCount" :disabled="ruleForm.jointPetition === 0"
                      placeholder="请输入联名人数"></el-input>
                  </el-form-item>
                </el-col>
              </el-row> -->

              <el-form-item label="诉求详情" prop="complaintRequest" style="form-style">
                <el-input type="textarea" placeholder="请输入诉求详情" maxlength="800" show-word-limit
                  v-model="ruleForm.complaintRequest" style="width: 880px;" :rows="4"
                  @blur="handleLeaveText"></el-input>
              </el-form-item>
              <el-form-item label="验证码" prop="email" class="f-last form-style">
                <div class="email-con">
                  <el-input v-model="ruleForm.email" placeholder="请输入验证码"></el-input>
                  <!-- <span class="form-email-2" @click="getEmail" v-show="isClickEmainl">获取验证码</span> -->
                  <img :src="ruleForm.emailImg" @click="getImg" alt="" class="form-email-img">
                  <span  @click="getImg" style="cursor: pointer;margin-left: 10px;">刷新</span>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="btn-form form-style">
                  <el-button class="btn-submit" type="primary" @click="submitForm('ruleForm')">提交</el-button>
                  <el-button class="btn-reset" @click="resetForm('ruleForm')">重置</el-button>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <!-- 表格区域（实名） -->
        <div class="form-content" v-show="isRealNameForm">
          <div class="f-title">信访诉求登记<span> (*为必填项)</span></div>
          <div class="f-cont">
            <el-form :model="realNameForm" :rules="realNameFormRules" ref="realNameForm" label-width="120px"
              class="demo-ruleForm">

              <el-form-item label="投诉标题" prop="complaintTitle" class="form-style">
                <el-input v-model="realNameForm.complaintTitle" style="width: 880px;" placeholder="请输入投诉标题"></el-input>
              </el-form-item>

              <!-- <el-form-item label="问题分类" prop="problemCategory" class="form-style">
                <el-select v-model="realNameForm.problemCategory" placeholder="请选择问题分类" :multiple="false"
                  style="width: 880px;">
                  <el-option v-for="item in troubleList" :key="item.qcId" :value="item.categoryName">
                  </el-option>
                </el-select>
              </el-form-item> -->

              <el-form-item label="问题所属协会" prop="association" class="form-SSXH">
                <el-select v-model="realNameForm.association" placeholder="请选择问题所属协会" style="width: 880px;">
                  <el-option v-for="item in associationList" :key="item.value" :value="item.association">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="问题发生地" class="form-style" prop="problemLocationList">
                <el-cascader v-model="realNameForm.problemLocationList" placeholder="请选择问题发生地" :props="props"  @expand-change="expandChange" @change="changeCascader"  ref="cascader1"
                  style="width: 880px;"></el-cascader>
              </el-form-item>

              <el-row class="switch-con">
                <el-col :span="6">
                  <el-form-item label="是否已有信访记录" prop="hasPetitionRecord" class="form-style">
                    <el-switch class="switch-con-left-one" v-model="realNameForm.hasPetitionRecord" :active-value="1"
                      :inactive-value="0"></el-switch>
                  </el-form-item>
                </el-col>

                <el-col :span="18">
                  <el-form-item label="相关处理结果" prop="petitionResult" class="form-style">
                    <el-input v-model="realNameForm.petitionResult" :disabled="realNameForm.hasPetitionRecord === 0"
                      placeholder="请输入相关处理结果"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row class="switch-con">
                <el-col :span="6">
                  <el-form-item label="是否联名信访" prop="jointPetition" class="form-style">
                    <el-switch class="switch-con-left-two" v-model="realNameForm.jointPetition" :active-value="1"
                      :inactive-value="0"></el-switch>
                  </el-form-item>
                </el-col>

                <el-col :span="18">
                  <el-form-item class="form-num form-style" prop="jointPetitionCount" label="联名人数">
                    <el-input type="number" max="50" @input="validateRealInput" @blur="handleRealBlur"
                      v-model="realNameForm.jointPetitionCount" :disabled="realNameForm.jointPetition === 0"
                      placeholder="请输入联名人数"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-form-item label="诉求详情" prop="complaintRequest" style="form-style">
                <el-input type="textarea" placeholder="请输入诉求详情" maxlength="800" show-word-limit
                  v-model="realNameForm.complaintRequest" width="880px" :rows="4"
                  @blur="handleLeaveRealText"></el-input>
              </el-form-item>

              <el-form-item>
                <div class="upload-demo">
                  <!-- <el-upload
                      class="upload-demo"
                      action=""
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      multiple
                      :limit="3"
                      :on-exceed="handleExceed"
                      :http-request="customUpload"
                      :file-list="realNameForm.fileList"
                      :before-upload="beforeUpload"
                      :on-error="handleError"
                      accept=".doc,.docx,.txt,.pdf,.xls,.xlsx,.jpg,.jpeg,.png"
                      >
                    </el-upload> -->
                  <el-upload class="upload-demo" :action="uploadUrl" :on-preview="handlePreview"
                    :on-remove="handleRemove" :limit="5" name="files" :headers="uploadHeaders" :on-exceed="handleExceed"
                    :file-list="realNameForm.fileList" :before-upload="beforeUpload" :on-error="handleError"
                    :on-success="successUpload">
                    <el-button size="small" type="primary" style="height: 35px;">上传附件</el-button>
                    <div slot="tip" class="el-upload__tip">
                      支持格式:doc、docx、txt、pdf、xls、xlsx、jpg、jpeg、png、mp3、mp4、avi、mov、mkv、flv，单个文件不能超过100MB,最多上传五个文件</div>
                  </el-upload>
                  <!-- <input type="file" ref="fileInput" @change="handleFileChange" /> -->
                  <!-- <el-button size="small" type="primary" @click="uploadFile">上传附件</el-button>
                  <div class="el-upload__tip"></div> -->
                </div>

              </el-form-item>



              <el-form-item label="验证码" prop="email" class="f-last form-style">
                <div class="email-con">
                  <el-input v-model="realNameForm.email" placeholder="请输入验证码"></el-input>
                  <!-- <span class="form-email-2" @click="getEmail" v-show="isClickEmainl">获取验证码</span> -->
                  <img :src="ruleForm.emailImg" @click="getImg" class="form-email-img" >
                  <span  @click="getImg" style="cursor: pointer;margin-left: 10px;">刷新</span>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="btn-form form-style">
                  <el-button class="btn-submit" type="primary" @click="submitRealForm('realNameForm')">提交</el-button>
                  <el-button class="btn-reset" @click="resetForm('realNameForm')">重置</el-button>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <!-- 联名人弹窗 (匿名)-->
        <!-- <el-dialog title="联名人" :visible.sync="isLianMing" class="isLianMing" width="700px">
          <div class="" v-for="(item, index) in ruleForm.complaintsJointlyS" :key="index">
            <div class="lianMingText">
            {{ getPersonLabel(index) }}:
            </div>
            <el-form :model="item" size="small" label-width="80px" :rules="lianMingRules" ref="complaintsJointlyS">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="姓名" prop="complaintsJointlyName">
                    <el-input v-model="item.complaintsJointlyName" autocomplete="off" placeholder="请输入姓名"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="手机号" prop="complaintsJointlyPhone">
                    <el-input v-model="item.complaintsJointlyPhone" autocomplete="off" placeholder="请输入手机号"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-form-item label="身份证号" prop="complaintsJointlyIdno">
                  <el-input v-model="item.complaintsJointlyIdno" autocomplete="off" placeholder="请输入身份证号"></el-input>
                </el-form-item>
              </el-row>
            </el-form>
          </div>

          <div slot="footer" class="dialog-footer">
            <el-button @click="isLianMing = false">取 消</el-button>
            <el-button type="primary" @click="handleIsLianMing('complaintsJointlyS')">确 定</el-button>
          </div>
        </el-dialog> -->
        <!-- 联名人弹窗 （实名）-->
        <el-dialog title="联名人" :visible.sync="isLianMingReal" :close-on-click-modal="false" class="isLianMing"
          width="700px">
          <div class="" v-for="(item, index) in realNameForm.complaintsJointlyS" :key="index">
            <div class="lianMingText">
              {{ getPersonLabel(index) }}:
            </div>
            <el-form :model="item" size="small" label-width="80px" :rules="lianMingRules" ref="complaintsJointlyS">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="姓名" prop="complaintsJointlyName">
                    <el-input v-model="item.complaintsJointlyName" autocomplete="off" placeholder="请输入姓名"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="手机号" prop="complaintsJointlyPhone">
                    <el-input v-model="item.complaintsJointlyPhone" autocomplete="off" placeholder="请输入手机号"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-form-item label="身份证号" prop="complaintsJointlyIdno">
                  <el-input v-model="item.complaintsJointlyIdno" autocomplete="off" placeholder="请输入身份证号"></el-input>
                </el-form-item>
              </el-row>
            </el-form>
          </div>

          <div slot="footer" class="dialog-footer">
            <el-button @click="isLianMingReal = false">取 消</el-button>
            <el-button type="primary" @click="handleRealIsLianMing('complaintsJointlyS')">确 定</el-button>
          </div>
        </el-dialog>

        <!-- 敏感词提示 -->
        <el-dialog title="提示" :visible.sync="isMinGan" width="30%" class="MinGanDialog">
          <span>检测到您的输入内容里有<span class="isMinGanClass">{{ minGanDate }}</span> 等敏感词或非法字符,请您修正，修正后再提交</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="isMinGan = false">取 消</el-button>
            <el-button type="primary" @click="isMinGan = false">确 定</el-button>
          </span>
        </el-dialog>

        <!-- 成功提示 -->
        <el-dialog :title="null" :visible.sync="successInfoTip" width="30%" center :close-on-click-modal="false"
          :close-on-press-escape="false" :show-close="false" class="successTip">
          <div class="successTipCon">
            <i class="el-icon-success"></i>
            <span>信件提交成功</span>
          </div>
          <img src="../assets/横线（蓝色）.png" alt="">
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="successSubmitConfirm">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
    <!-- 底部 -->
    <div class="footer" style="align-items: center;justify-content: center;display: flex;">运维电话:（010）5929 1061</div>
  </div>
</template>

<script>
import { getNiMingApi, getAssociationApi } from '@/api/index'
import { getCaptchaImageApi } from '@/api/login'
import axios from 'axios'
export default {
  computed: {
    uploadHeaders () {
      return {
        'Authorization': 'Bearer ' + this.token
      };
    }
  },
  data () {
    return {
      fileTypeError: false,
      token: '',
      uploadUrl: window.apiurl + '/common/uploads',
      checked: false, //  阅读以下条款绑定，控制按钮展示
      Guidelines: true, //  控制须知与表格显示
      isRealNameForm: false, //  是否实名
      isAnonymousForm: false, //  是否匿名
      isLianMing: false,  //  控制是否联名弹窗(匿名)
      isLianMingReal: false,  //  控制是否联名弹窗(实名)
      ruleForm: {
        complaintTitle: '',
        problemCategory: '',
        anonymityEmail: '',
        association: '',
        problemLocationList: [],  //  问题发生地
        hasPetitionRecord: 0,
        petitionResult: '',
        jointPetition: 0, //  是否联名信访
        jointPetitionCount: '',
        complaintRequest: '',
        email: '',
        emailImg: '',
        autonym: '0', // 是否实名
        complaintsName: '匿名', // 信访人姓名

        // 联名人数
        complaintsJointlyS: Array(10).fill(null).map(() => ({ complaintsJointlyName: '', complaintsJointlyPhone: '', complaintsJointlyIdno: '' })),
      },
      isClickEmainl: true, //  是否点击获取验证码
      rules: {
        complaintTitle: [
          {
            required: true,
            message: '投诉标题不能为空',
            trigger: 'blur'
          }
        ],
        problemLocationList: [
          {
            required: true,
            message: '问题发生地不能为空',
            trigger: 'blur'
          }
        ],
        problemCategory: [
          {
            required: true,
            message: '问题分类不能为空',
            trigger: 'blur'
          }
        ],
        association: [
          {
            required: true,
            message: '问题所属协会不能为空',
            trigger: 'blur'
          }
        ],
        anonymityEmail: [
          {
            // 使用正则表达式进行邮箱格式校验
            pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            message: '请输入有效的电子邮箱地址',
            trigger: 'blur'  // 在输入框失去焦点时进行验证
          }
        ],
        // problemLocation: [
        //   {
        //     required: true,
        //     message: '问题发生地不能为空',
        //     trigger: 'blur'
        //   }
        // ],
        complaintRequest: [
          {
            required: true,
            message: '投诉请求不能为空',
            trigger: 'blur'
          }, {
            max: 800,
            message: '投诉请求不能超过800个字',
            trigger: 'blur'
          }
        ],
        email: [
          {
            required: true,
            message: '验证码不能为空',
            trigger: 'blur'
          }
        ]
      },
      troubleList: [],  //  问题分类
      associationList: [],  //  问题所属协会

      // 动态加载数据
      props: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: (node, resolve) => {
          const { level } = node // 获取当前节点的级别

          // 根据不同的 level 判断需要的参数
          let apiUrl = ''
          let params = {}

          let keyIndex = ''

          // 判断是否为直辖市（北京、上海、天津、重庆）
          const directMunicipalities = ['北京市', '上海市', '天津市', '重庆市'] // 直辖市的名称数组
          const isDirectMunicipality = directMunicipalities.includes(node.label) || ['100000', '1000008', '1000001', '1000021'].includes(node.value) // 直辖市的代码数组

          if (node.data) {
            keyIndex = node.data.key
          }

          if (level === 0) {
            // 第一级，获取省级数据
            apiUrl = window.apiurl + '/claim/registration/selectAddress'
            params = { regionLevel: '1' } // 假设 '1' 是第一级，具体根据实际情况调整
          } else if (level === 1 && node.data) {
            // 第二级，获取该区域的子节点数据
            apiUrl = window.apiurl + '/claim/registration/getAddrByParentId'
            params = { regionParentId: keyIndex } // 传递父级节点的 ID
          } else if (level === 2 && node.data) {
            // 第三级，根据是否为直辖市来决定是否加载子节点
            if (isDirectMunicipality) {
              resolve([])
              return
            } else {
              apiUrl = window.apiurl + '/claim/registration/getAddrByParentId'
              params = { regionParentId: keyIndex }
            }
          } else {
            resolve([])
            return
          }
          this.getProblemLocation(apiUrl, params)
            .then((res) => {
              // console.log('res', res)
              if (res.data.data && res.data.data.length === 0) {
                // 如果返回数据为空且当前节点是直辖市（并且是第二级），不显示 "暂无数据"
                if (isDirectMunicipality && level === 1) {
                  resolve([]) // 返回空数组，表示没有子节点
                } else {
                  resolve([]) // 也可以在其他情况下返回空数组
                }
              } else {
                const nodes = []
                res.data.data.forEach((item) => {
                  const area = {
                    value: item.regionName,
                    label: item.regionName,
                    key: item.regionId,
                    leaf: level >= 2 || (isDirectMunicipality && level === 1) // 如果是三级节点，且不是直辖市，才加载子节点
                  }
                  // console.log('area', area)
                  nodes.push(area)
                })
                // console.log('nodes', nodes)
                resolve(nodes) // 返回加载的节点
              }
            })
            .catch((error) => {
              console.log(error)
              // 可以在这里处理错误，例如显示提示信息
            })
        }
      },

      // 联名规则
      lianMingRules: {
        complaintsJointlyName: [
          { required: true, message: '姓名不能为空', trigger: 'blur' },
          { min: 2, max: 5, message: '姓名长度应为2-5个字符', trigger: 'blur' }
        ],
        complaintsJointlyPhone: [
          { required: true, message: '手机号不能为空', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
        ],
        complaintsJointlyIdno: [
          { required: false, message: '身份证号不能为空', trigger: 'blur' },
          { pattern: /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/, message: '身份证号格式不正确', trigger: 'blur' }
        ]
      },

      // 实名
      realNameForm: {
        complaintTitle: '',
        problemCategory: '',
        association: '',
        problemLocationList: [],
        hasPetitionRecord: 0,
        petitionResult: '',
        jointPetition: 0, //  是否联名信访
        jointPetitionCount: '',
        complaintRequest: '',
        email: '',
        complaintsJointlyS: Array(10).fill(null).map(() => ({ complaintsJointlyName: '', complaintsJointlyPhone: '', complaintsJointlyIdno: '' })),

        autonym: 1, // 是否实名
        complaintsName: '匿名', // 信访人姓名

        fileList: [],

        userID: ''
      },
      realNameFormRules: {
        problemLocationList: [
          {
            required: true,
            message: '问题发生地不能为空',
            trigger: 'blur'
          }
        ],
        complaintTitle: [
          {
            required: true,
            message: '投诉标题不能为空',
            trigger: 'blur'
          }
        ],
        problemCategory: [
          {
            required: true,
            message: '问题分类不能为空',
            trigger: 'blur'
          }
        ],
        association: [
          {
            required: true,
            message: '问题所属协会不能为空',
            trigger: 'blur'
          }
        ],
        // problemLocation: [
        //   {
        //     required: true,
        //     message: '问题发生地不能为空',
        //     trigger: 'blur'
        //   }
        // ],
        complaintRequest: [
          {
            required: true,
            message: '投诉请求不能为空',
            trigger: 'blur'
          }, {
            max: 800,
            message: '投诉请求不能超过800个字',
            trigger: 'blur'
          }
        ],
        email: [
          {
            required: true,
            message: '验证码不能为空',
            trigger: 'blur'
          }
        ]
      },

      //  与敏感词相关
      minGanDate: [],
      isMinGan: false,

      // fileList: []

      successInfoTip: false,


      userID: '',

      isHaveMinGanCi: '',

      isFieldBlurred: false,  // 记录字段是否失去焦点

      complaintType: '', // 投诉选择 卡片的 类型 1、足球领域吃拿卡要等“微腐败”和不正之风问题举报  2、足球领域“假赌黑”（假球、赌球、黑哨）问题举报  3、其他足球领域问题举报 
    }
  },
  methods: {
    async submitForm (formName) {
      try {
        // 如果字段未失去焦点，直接返回
        if (!this.isFieldBlurred) {
          this.$message.warning('请先失去焦点并验证字段')
          this.isFieldBlurred = ''
          return
        }
        const valid = await this.$refs[formName].validate()
        // console.log('valid', valid)
        // console.log('this.isHaveMinGanCi', this.isHaveMinGanCi)
        if (this.isHaveMinGanCi == true) {
          this.$message.error('您的诉求详情中包含敏感词或非法字符，请您修正后再提交')
          return
        }
        if (valid && this.isHaveMinGanCi !== true) {
          var data = JSON.parse(JSON.stringify(this.ruleForm));
          if (data.jointPetition == 0) {
            delete data['complaintsJointlyS']
          }
          const res = await axios.post(window.apiurl + '/claim/registration/addComplaints', {...this.ruleForm, code: this.ruleForm.email})
          console.log('API响应', res)
          console.log('表单数据:', this.ruleForm)
          if(res.data.code ==200) {
            this.successInfoTip = true
          } else {
             this.$message.error(res.data.msg)
          }
        } else {
          console.log('表单验证失败')
        }
      } catch (err) {
        console.log('表单验证或API请求出错: ', err)
        this.$message.error('表单提交失败，请稍后再试')
        return false
      } finally {
        // 在表单提交结束后，无论成功与否，都清空 isFieldBlurred 以供下一次操作
        this.isFieldBlurred = ''
      }
    },
    async submitRealForm (formName) {
      try {
        // 如果字段未失去焦点，直接返回
        if (!this.isFieldBlurred) {
          this.$message.warning('请先失去焦点并验证字段')
          this.isFieldBlurred = ''
          return
        }
        const valid = await this.$refs[formName].validate()
        // console.log('valid', valid)
        // console.log('this.isHaveMinGanCi', this.isHaveMinGanCi)
        if (this.isHaveMinGanCi == true) {
          this.$message.error('您的诉求详情中包含敏感词或非法字符，请您修正后再提交')
          return
        }
        if (valid && this.isHaveMinGanCi !== true) {
          // console.log('this.ruleFormReal', this.realNameForm)
          const res = await axios.post(window.apiurl + '/claim/registration/addComplaints', {...this.realNameForm, code: this.realNameForm.email, uuid: this.ruleForm.uuid})
          console.log('API响应', res)
          console.log('表单数据:', this.realNameForm)
          if(res.data.code ==200) {
            this.successInfoTip = true
          } else {
             this.$message.error(res.data.msg)
          }
        } else {
          console.log('表单验证失败')
        }
      } catch (err) {
        console.log('表单验证或API请求出错: ', err)
        this.$message.error('表单提交失败，请稍后再试')
        return false
      } finally {
        // 在表单提交结束后，无论成功与否，都清空 isFieldBlurred 以供下一次操作
        this.isFieldBlurred = ''
        this.isHaveMinGanCi = false
      }
    },

    resetForm (formName) {
      this.$refs[formName].resetFields()
    },

    // 点击跳转匿名
    toNiMing () {
      // this.Guidelines = false
      // this.isAnonymousForm = true
      this.$router.push({
        path: '/portalnm',
        query: {

        }
      })
    },

    // 点击跳转实名
    toShiMing () {
      console.log('this.$store.state.token', this.$store.state.token)
      this.$router.push({
        path: '/portal',
      })
      return
      if (this.$store.state.token) {
        this.Guidelines = false
        this.isRealNameForm = true
      } else {
        this.$router.push({
          path: '/portal',
          query: {
            redirect: '/logindex?am=shuming'
          }
        })
        this.Guidelines = false
        this.isRealNameForm = true
      }
    },

    // 保证输入的是一个非负数(匿名)
    validateInput () {
      if (this.ruleForm.jointPetitionCount < 0) {
        this.ruleForm.jointPetitionCount = 0 // 将负数值强制设为0
        this.$message.warning('联名人数不能为负数')
      }
    },
    // 保证输入的是一个非负数（实名）
    validateRealInput () {
      if (parseInt(this.realNameForm.jointPetitionCount) < 0) {
        this.realNameForm.jointPetitionCount = 0 // 将负数值强制设为0
        this.$message.warning('联名人数不能为负数')
      } else if (parseInt(this.realNameForm.jointPetitionCount) > 50) {
        this.realNameForm.jointPetitionCount = 50 // 将负数值强制设为50
        this.$message.warning('联名人数最多50人')
      }
    },

    // 鼠标失去焦点(匿名)
    handleBlur () {
      if (this.ruleForm.jointPetitionCount == 0) {
        this.isLianMing = false
      } else {
        this.isLianMing = true
      }
    },
    // 鼠标失去焦点（实名）
    handleRealBlur () {
      if (this.realNameForm.jointPetitionCount == 0) {
        this.isLianMingReal = false
      } else {
        this.isLianMingReal = true
      }
    },

    // 定义不同的称呼
    getPersonLabel (index) {
      const labels = ['第一人', '第二人', '第三人', '第四人', '第五人'];
      return labels[index] || `第${index + 1}人`; // 默认返回“第N人”
    },
    // 是否联名校验
    handleRealIsLianMing (formName) {
      let allValid = true  // 标志所有表单是否都验证通过
      const formPromises = []  // 存储每个表单的验证 Promise
      // 遍历所有表单
      for (let i = 0; i < this.$refs[formName].length; i++) {
        const form = this.$refs[formName][i]
        if (form) {
          // 每个表单验证操作封装成 Promise
          const formValidationPromise = new Promise((resolve, reject) => {
            form.validate((valid) => {
              if (valid) {
                console.log('this.complaintsJointlyS', this.complaintsJointlyS)

                resolve()  // 验证通过
              } else {
                reject()  // 验证失败
              }
            })
          })
          formPromises.push(formValidationPromise)  // 将每个验证的 Promise 加入队列
        }
      }
      // 等待所有表单的验证完成
      Promise.all(formPromises)
        .then(() => {
          // 如果所有验证通过
          this.isLianMingReal = false  // 执行其他操作
        })
        .catch(() => {
          // 如果有任意表单验证失败
          this.$message.error('联名人填写信息有误,请检查')
          this.isLianMingReal = true  // 根据情况设置状态
        })
    },

    // // 是否联名校验(匿名)
    // handleRealIsLianMing(formName) {
    //   debugger
    //   console.log(this.$refs)
    //   this.$ref[formName].validate((valid) => {
    //     debugger;
    //     if (valid) {
    //       this.isLianMing = false
    //       return true;
    //     } else {
    //       this.$message.error('表单校验未通过,请检查联名人填写信息')
    //       return false;
    //     }
    //   });
    //    // 执行其他操作
    // },

    toLogin () {
      this.$router.push('flogin')
    },
    toTS () {
      this.$router.push('logindex')
    },
    toJY () {
      this.$router.push('advise')
    },
    toJL () {
      this.$router.push('log')
    },
    toNews () {
      this.$router.push('news')
    },
    toPass () {
      this.$router.push('pass')
    },
    toHelp () {
      this.$router.push('help')
    },
    // 点击验证码出现图片
    async getEmail () {
      this.isClickEmainl = !this.isClickEmainl
      const res = await getCaptchaImageApi()
      console.log('resaaaaaa', res)
      this.ruleForm.emailImg = 'data:image/gif;base64,' + res.img
      this.ruleForm.uuid = res.uuid
      // console.log('this.ruleForm.emailImg', this.ruleForm.emailImg)
    },
    // 获取验证码
    async getImg () {
      const res = await getCaptchaImageApi()
      console.log('获取验证码', res)
      this.ruleForm.emailImg = 'data:image/gif;base64,' + res.img
      this.ruleForm.uuid = res.uuid
    },
    // 获取问题分类
    async getTroubleList () {
      try {
        // const res = await getTroubleListApi()
        const res = await axios.get(window.apiurl + '/questionCategories/list/complaintsTree?pageSize=1000')
        // console.log('resaaa', res)
        const item = res.data.rows.filter(x => x.qcId == this.complaintType)
        this.troubleList = item && item[0].children || []
        // console.log('this.troubleList', this.troubleList)

        // this.troubleList.forEach((item, index) => {
        //   console.log(`Item ${index}:`, item);
        //   console.log(`categoryName`, item.categoryName);
        // })


      } catch (error) {
        console.log('error ---', error)
      }
    },
    // 获取问题所属协会
    async getSSXHList () {
      try {
        const res = await getAssociationApi()
        // console.log('res', res)
        const deptNames = res.data.map(item => item.deptName)
        const associationListaaa = deptNames.map((dept, index) => ({
          value: (index + 1).toString(), // 将索引加1作为 value
          association: dept // 部门名称作为 association
        }))
        this.associationList = associationListaaa
      } catch (error) {
        console.log('error', error)
      }
    },
    // 获取省市区
    getProblemLocation (apiUrl, params) {
      return new Promise((resolve, reject) => {
        axios.get(apiUrl, { params: params }) // 传递正确的参数
          .then((res) => {
            if (res.data && res.data.data) {
              resolve(res) // 返回请求的数据
            } else {
              reject(new Error('数据为空'))
            }
          })
          .catch((error) => {
            reject(error) // 请求失败，返回错误
          })
      })
    },

    // 退出
    logout () {
      alert('退出登录')
      this.$store.commit('delToken')
      window.location.href = '/'
    },

    // 失去焦点，验证敏感词（匿名）
    async handleLeaveText () {
      const text = this.ruleForm.complaintRequest
      try {
        const res = await axios.post(window.apiurl + '/claim/registration/verify', {
          text: text
        })
        console.log('res', res)

        if (res.status == 200) {
          this.isFieldBlurred = true
        } else {
          this.isFieldBlurred = false
        }

        // console.log('this.isFieldBlurred', this.isFieldBlurred)

        const resultString = res.data.data.join(' ')
        this.minGanDate = resultString
        // 使用 join 方法将数组转换为字符串，默认使用逗号分隔

        // console.log('res.data.data', res.data.data)
        // console.log('res.data.data.length', res.data.data.length)

        if (res.data.data && res.data.data.length) {
          this.isMinGan = true
          this.isHaveMinGanCi = true
        } else {
          this.isMinGan = false
          this.isHaveMinGanCi = false
        }
        return resultString
      } catch (error) {
        console.log('error', error)
        return null
      }
    },
    // 失去焦点，验证敏感词（实名）
    async handleLeaveRealText () {
      const text = this.realNameForm.complaintRequest
      try {
        const res = await axios.post(window.apiurl + '/claim/registration/verify', {
          text: text
        })
        console.log('res', res)

        if (res.status == 200) {
          this.isFieldBlurred = true
        } else {
          this.isFieldBlurred = false
        }

        const resultString = res.data.data.join(' ')
        this.minGanDate = resultString
        // 使用 join 方法将数组转换为字符串，默认使用逗号分隔
        if (res.data.data && res.data.data.length) {
          this.isMinGan = true
          this.isHaveMinGanCi = true
        } else {
          this.isMinGan = false
          this.isHaveMinGanCi = false
        }
        return resultString
      } catch (error) {
        console.log('error', error)
        return null
      }
    },

    // 获取个人信息
    async getUserInfo () {
      try {
        const token = this.$store.state.token
        console.log('token', token)
        if (token) {
          this.token = token;
        } else {
          return;
        }


        const res = await axios.get(window.apiurl + '/op/user/getInfo', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
        if (res.data.code == 200) {
          this.$store.commit('setUserInfo', res.data.user)
          this.realNameForm.userID = res.data.user.userId
          this.realNameForm.complaintsName = this.$store.state.userInfo.nickName
        }

      } catch (error) {
        console.log('error', error)
      }
    },
    successUpload (response, file, fileList) {
      console.log(response)
      console.log(file)
      console.log(fileList)
      var files = [];
      for (var i = 0; i < fileList.length; i++) {
        files.push(fileList[i].response.urls)
      }
      if (this.isAnonymousForm) {
        this.ruleForm.attachmentAddress = JSON.stringify(files);
      } else if (this.isRealNameForm) {
        this.realNameForm.attachmentAddress = JSON.stringify(files);
      }

    },
    // 文件上传前进行额外的检查
    beforeUpload (file, fileList) {
      console.log(file.type);
      // 1. 检查文件类型
      const validTypes = [
        'application/msword', // doc
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // docx
        'text/plain', // txt
        'application/pdf', // pdf
        'application/vnd.ms-excel', // xls
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // xlsx
        'image/jpeg', // jpeg/jpg
        'audio/mpeg', // mp3
        'video/mp4', // mp4
        'video/avi', // mp4
        'video/quicktime', // mov
        'logindex.vue:1096 video/x-matroska', // mkv
        'image/png' // png
      ]
      if (!validTypes.includes(file.type)) {
        var names = file.name.split('.');
        if (names[names.length - 1] == 'flv') {

        } else {
          this.fileTypeError = true;
          this.$message.error('只支持上传 doc、docx、txt、pdf、xls、xlsx、jpg、jpeg、png、mp3、mp4、avi、mov、mkv、flv 文件格式')
          return false  // 阻止上传
        }
      }

      // 2. 检查文件大小（限制为 5MB）
      const isLt5MB = file.size / 1024 / 1024 < 100  // 5MB
      if (!isLt5MB) {
        this.fileTypeError = true;
        this.$message.error('文件大小不能超过 100MB')
        return false  // 阻止上传
      }
      console.log('fileList', fileList)

      // this.realNameForm.fileList = fileList

      return true  // 允许上传


    },

    // 用户点击文件列表中的文件预览时触发
    handlePreview (file) {
      // 如果是图片文件，进行图片预览
      if (file.raw.type.includes('image')) {
        const imageUrl = URL.createObjectURL(file.raw || file);  // 使用 file.raw 或直接使用 file（根据实际情况）

        // 创建一个新的窗口展示图片
        const imageWindow = window.open('', '_blank');
        imageWindow.document.write(`
      <html>
        <body style="text-align: center; padding: 20px;">
          <img src="${imageUrl}" style="max-width: 100%; height: auto;" />
        </body>
      </html>
    `);
      }
      // 如果是 PDF 文件，尝试用 iframe 进行预览
      else if (file.raw.type === 'application/pdf') {
        const pdfUrl = URL.createObjectURL(file.raw || file);
        const pdfWindow = window.open('', '_blank');
        pdfWindow.document.write(`
      <html>
        <body>
          <iframe src="${pdfUrl}" width="100%" height="100%" style="border: none;"></iframe>
        </body>
      </html>
    `);
      } else {
        console.log(file);
        window.open(file.response.urls, '_blank');
      }

      // 如果是 Office 文件（如 Word、Excel），提示用户不支持预览
      // else if (file.raw.type.includes('application/msword') || file.raw.type.includes('application/vnd.openxmlformats-officedocument.wordprocessingml.document')) {
      //   this.$message.info('暂不支持预览 Word 文件');
      // }
      // else {
      //   this.$message.info('文件预览暂不支持此格式');
      // }
    },
    // 用户点击删除文件时触发
    handleRemove (file, fileList) {
      var files = [];
      for (var i = 0; i < fileList.length; i++) {
        files.push(fileList[i].response.urls)
      }
      if (this.isAnonymousForm) {
        this.ruleForm.attachmentAddress = JSON.stringify(files);
      } else if (this.isRealNameForm) {
        this.realNameForm.attachmentAddress = JSON.stringify(files);
      }
    },
    // 删除文件之前的钩子
    beforeRemove (file, fileList) {
      if (!this.fileTypeError) {
        console.log('删除之前', file);
        console.log('删除之前fileList', fileList);
        return new Promise((resolve, reject) => {
          this.$confirm('确定要删除该文件吗？', '删除文件', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            resolve();
          }).catch(() => {
            reject();
          });
        });
      } else {

        this.fileTypeError = false;
        return true;
      }
    },
    // 文件数超过 limit 限制
    handleExceed (file, fileList) {
      console.log('超过限制', file)
      console.log('超过限制fileList', fileList)
      this.$message.error('文件数量超过限制')
    },

    // 上传成功后的处理
    // handleSuccess(response, file, fileList) {
    //   // 文件上传成功时的回调
    //   this.$message.success('文件上传成功');
    //   console.log('上传成功', response, file);
    //   // 可以在这里更新文件列表
    //   this.realNameForm.fileList = fileList;
    //   console.log('this.realNameForm.fileList', this.realNameForm.fileList)
    // },

    // 上传失败后的处理
    handleError (err, file, fileList) {
      // 文件上传失败时的回调
      this.$message.error('文件上传失败');
      console.error('上传失败', err, file);
      // 可以在这里更新文件列表
      this.realNameForm.fileList = fileList;
    },
    customUpload (file) {
      const formData = new FormData();
      formData.append('file', file);
      console.log('formData', formData)
      axios.post(window.apiurl + '/common/uploads', formData)
        .then(response => {
          console.log('上传成功', response);
        })
        .catch(error => {
          console.error('上传失败', error);
        });
    },
    successSubmitConfirm () {
      window.location.href = '/logindex'
    },
    async uploadFile () {
      console.log('上传')
      // try {
      //   const res = await aixos.post(window.apiurl+'/common/uploads')
      //   console.log('res', res)
      // } catch(error) {
      //   console.log('error', error)
      // }
    },
    // // 处理文件选择
    // handleFileChange(event) {
    //     const file = event.target.files[0];
    //     if (file) {
    //       this.file = file;
    //     }
    //   },
    expandChange(node) {
    },
    changeCascader(value) { 
      this.$nextTick(()=> {
        this.$refs.cascader1._data.dropDownVisible = false
        this.$refs.cascader2._data.dropDownVisible = false
      })
    },
  },
  mounted () {
   
    this.complaintType = this.$router.currentRoute.query.complaintType
    if (this.$router.currentRoute.query.am === 'shuming') {
      this.Guidelines = false
      this.isRealNameForm = true
    }
    if (this.$router.currentRoute.query.from === 'anonymous') {
      this.Guidelines = false
      this.isAnonymousForm = true
     
    }
    //  this.getTroubleList()
    this.getSSXHList()
    this.getUserInfo()
    this.getEmail()
  },
  watch: {
    ruleForm: {
      handler (newVal, oldVal) {
        if (newVal.jointPetitionCount > this.ruleForm.complaintsJointlyS.length) {
          // 如果人数超过表单数据的长度，扩展 complaintsJointlyS
          this.ruleForm.complaintsJointlyS.push(...Array(newVal.jointPetitionCount - this.ruleForm.complaintsJointlyS.length).fill(null).map(() => ({ complaintsJointlyName: '', complaintsJointlyPhone: '', complaintsJointlyIdno: '' })));
        } else if (newVal.jointPetitionCount < this.ruleForm.complaintsJointlyS.length) {
          // 如果人数少于当前表单项，截取多余的项
          this.ruleForm.complaintsJointlyS = this.ruleForm.complaintsJointlyS.slice(0, newVal.jointPetitionCount)
        }
      },
      deep: true // 深度监听
    },
    realNameForm: {
      handler (newVal, oldVal) {
        if (newVal.jointPetitionCount > this.realNameForm.complaintsJointlyS.length) {
          // 如果人数超过表单数据的长度，扩展 complaintsJointlyS
          this.realNameForm.complaintsJointlyS.push(...Array(newVal.jointPetitionCount - this.realNameForm.complaintsJointlyS.length).fill(null).map(() => ({ complaintsJointlyName: '', complaintsJointlyPhone: '', complaintsJointlyIdno: '' })));
        } else if (newVal.jointPetitionCount < this.realNameForm.complaintsJointlyS.length) {
          // 如果人数少于当前表单项，截取多余的项
          this.realNameForm.complaintsJointlyS = this.realNameForm.complaintsJointlyS.slice(0, newVal.jointPetitionCount)
        }
      },
      deep: true // 深度监听
    },
  },
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.container {
  background: url('/src/assets/bgc1.jpg') no-repeat;
  background-size: 100% 100%;
  min-height: calc(100vh - 55px);
}

/* 头部 */
.top {
  text-shadow: 2px 2px 1px #000;
  width: 1200px;
  height: 130px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
}

.t-f-1 {
  color: #fff;
  font-size: 40px;
  font-weight: 700;
  text-align: center;
}

.t-f-2 {
  font-size: 16px;
  color: #fff;
}

.t-right {
  display: flex;
  align-items: center;
}

.t-r-1 {
  font-size: 18px;
  font-weight: 600;
  margin-right: 50px;
  color: #fff;
}

.t-r-2 {
  text-align: center;
}

.t-r-2:hover {
  cursor: pointer;
}

.t-r-2 img {
  width: 26px;
  height: 28px;
  margin-bottom: 5px;
}

.t-r-2 p {
  color: #fff;
}

/* nav */
.m-title {
  width: 100%;
  height: 50px;
  background-color: #327fd3;
  display: flex;
  justify-content: center;
  align-items: center;
}

.m-t-item {
  width: 200px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
}

.active {
  background-color: #1a62b0;
}

/* 主体 --- 内容 */
.content {
  width: 1200px;
  margin: 40px auto;
  background: #fff;
  border-radius: 5px;
  padding: 40px;
  box-shadow: 2px 3px 29px 0 rgba(50, 127, 211, .17);
}

.c-title {
  height: 50px;
  background-color: #8cbef4;
  font-size: 16px;
  line-height: 50px;
  text-align: left;
  padding-left: 20px;
  border-radius: 5px;
  color: #fff;
  margin-bottom: 20px;
}

.c-cont {
  padding-top: 40px;
  width: 1000px;
  margin: 0 auto;
}

.c-cont p {
  text-indent: 20px;
  font-size: 16px;
  line-height: 35px;
  text-align: left;
}

.c-cont .p-indent {
  text-indent: 40px;
}

.checkContainer {
  margin: 20px 0px;
  display: flex;
  justify-content: center;
}

.btnContainer {
  display: flex;
  justify-content: center;
}

.noC {
  margin-right: 15px;
  cursor: not-allowed;
}

.Can {
  cursor: not-allowed;
}

.tiaozhuan {
  cursor: pointer;
}

/* 表格 */
.form-content {
  width: 1200px;
  margin: 40px auto;
  background: #fff;
  border-radius: 5px;
  padding: 40px;
  box-shadow: 2px 3px 29px 0 rgba(50, 127, 211, .17);
}

.f-title {
  height: 50px;
  background-color: #8cbef4;
  font-size: 16px;
  line-height: 50px;
  text-align: left;
  padding-left: 20px;
  border-radius: 5px;
  color: #fff;
  margin: 40px 60px 0 60px;
}

.f-title span {
  color: red;
}

.f-cont {
  width: 1000px;
  margin: 0 auto;
  padding-top: 20px;
}

::v-deep .el-input__inner,
.el-textarea__inner {
  border: 1px solid #327fd3 !important;
}

/* ::v-deep .el-form-item__label {
  width: 120px !important;
} */

::v-deep .switch-change .el-form-item__label {
  padding: 0;
}

::v-deep .switch-change .el-col-6 {
  width: 25%;
  padding: 0 60px;
}

::v-deep .switch-change .el-col-6:first-child {
  padding-left: 0;
}

::v-deep .switch-change .el-col-6:nth-child(2) {
  padding-left: 30px;
}

::v-deep .switch-change .el-col-6:last-child {
  padding-left: 75px;
  padding-right: 0;
}

::v-deep .switch-change .el-form-item__content {
  margin-left: 120px !important;
  width: 55px;
}

::v-deep .switch-change .el-switch__core {
  margin-left: 10px;
}

::v-deep .switch-con .el-input {
  width: 620px;
}

::v-deep .switch-con .el-form-item__label {
  padding: 0;
}

/* ::v-deep .switch-con .el-form-item {
  margin-left: 15px;
} */
::v-deep .switch-con .el-form-item__label {
  margin-right: 10px;
}

::v-deep .el-textarea__inner {
  height: 74.6px;
  border: 1px solid #327fd3 !important;
}

.el-upload__tip {
  color: red;
  margin-left: 20px;
}

.f-last .el-input {
  width: 250px;
}

.el-upload__tip {
  height: 20px;
  line-height: 20px;
}

.btn-form {
  display: flex;
  justify-content: center;
  margin-right: 45px;
}

.btn-submit {
  width: 190px;
  height: 35px;
}

.btn-reset {
  width: 190px;
  height: 35px;
}

/* ::v-deep .form-num .el-form-item__label .el-form-item__required {
  display: none;
} */
::v-deep .form-num .el-form-item__error {
  margin-left: 30px;
}

/* 错误提示 */
::v-deep .el-form-item__error {
  margin-left: 20px;
}

/* .form-email {
  border: none;
  color: red;
  width: 70px;
  height: 40px;
}
.form-email:hover {
  background-color: #fff;
  color: red;
  border-bottom: 1px solid red;
} */
.email-con {
  display: flex;
}

.form-email-2 {
  display: flex;
  width: 70px;
  height: 40px;
  margin-left: 20px;
  color: red;
}

.form-email-2:hover {
  cursor: pointer;
  border-bottom: 1px solid #409eff;
}

.form-email-img {
  width: 100px;
  height: 38px;
  margin-left: 20px;
}

/* 底部 */
.footer {
  width: 100%;
  height: 55px;
  background: #327fd3;
  color: #fff;
}

/* 表单 */
.el-form-item {
  margin-bottom: 22px;
}

/* switch开关 */
.switch-con-left-one {
  margin-left: -75px;
}

.switch-con-left-two {
  margin-left: -75px;
}

/* 下拉框 */
.el-select-dropdown__item {
  padding-left: 20px;
}

/* 联名人弹窗 */
::v-deep .isLianMing .el-dialog__header {
  background-color: #409eff;
}

::v-deep .isLianMing .el-dialog__title {
  color: #fff;
}

::v-deep .isLianMing .el-dialog__close {
  color: #fff;
}

.lianMingText {
  font-weight: 700;
  color: #333;
  margin-bottom: 10px;
  text-align: left;
}

::v-deep .isLianMing .el-button {
  width: 95px;
  height: 35px;
}

.MinGanDialog .el-button {
  width: 80px;
  height: 40px;
}

/* 设置下划线和红色字体 */
.isMinGanClass {
  font-size: 18px;
  /* 增大字体 */
  text-decoration: underline;
  color: red;
}

/* 上传 */
.upload-demo {
  text-align: left;
}

.upload-demo .el-button {
  width: 80px;
  height: 30px;
}

.upload-demo .el-upload__tip {
  margin-left: 0;
}

::v-deep .successTip .el-dialog__header {
  display: none;
}

::v-deep .successTip .el-icon-success {
  font-size: 25px;
  width: 25px;
  height: 25px;
  color: blue;
}

::v-deep .successTip .el-dialog__body {
  padding-bottom: 10px;
}

.successTipCon {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 25px;
  line-height: 25px;
}

.successTipCon span {
  color: #327fd3;
  font-size: 18px;
  margin-left: 5px;
}

.successTip .el-button {
  width: 190px;
  height: 40px;
}
</style>
